const topics = [
  { id: 1, name: '娱乐圈大瓜', heat: '128万讨论', icon: 'ri-star-line', color: 'text-primary-500 bg-primary-50' },
  { id: 2, name: '明星塌房实录', heat: '96万讨论', icon: 'ri-alert-line', color: 'text-accent-500 bg-accent-50' },
  { id: 3, name: '综艺争议现场', heat: '83万讨论', icon: 'ri-tv-line', color: 'text-secondary-500 bg-secondary-50' },
  { id: 4, name: '网红圈内幕', heat: '75万讨论', icon: 'ri-user-smile-line', color: 'text-primary-500 bg-primary-50' },
  { id: 5, name: '影视剧吐槽', heat: '68万讨论', icon: 'ri-film-line', color: 'text-accent-500 bg-accent-50' },
  { id: 6, name: '恋情实锤', heat: '61万讨论', icon: 'ri-heart-line', color: 'text-secondary-500 bg-secondary-50' },
  { id: 7, name: '饭圈风云', heat: '55万讨论', icon: 'ri-thunderstorms-line', color: 'text-primary-500 bg-primary-50' },
  { id: 8, name: '私下爆料投稿', heat: '49万讨论', icon: 'ri-mail-unread-line', color: 'text-accent-500 bg-accent-50' },
  { id: 9, name: '跨界大事件', heat: '44万讨论', icon: 'ri-rocket-line', color: 'text-secondary-500 bg-secondary-50' },
];

export default function TopicsSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.querySelector('#cards');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              话题广场
            </h2>
            <p className="text-sm text-foreground-500">
              九大热门话题板块，找到你感兴趣的瓜田
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
            {topics.map((t) => (
              <a
                key={t.id}
                href="#cards"
                onClick={handleClick}
                className="flex items-center gap-4 bg-background-100 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
              >
                <div className={`w-10 h-10 rounded-lg ${t.color} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${t.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{t.name}</h3>
                  <p className="text-xs text-foreground-400 mt-0.5">{t.heat}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}